import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Typography,
  Card,
  Button,
  IconButton,
  Stack,
  Tooltip,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import {
  useLocation
} from "react-router-dom";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm, Controller } from "react-hook-form";
import { makeStyles } from '@mui/styles';
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import SelectDropdown from "../common/FormSelectDropdown";
import TextInput from "../common/TextInput";
import { errorToast, successToast, warningToast } from "../../utils/toast";
import { ToastContainer } from "react-toastify";
import useLocalStorage from "../../../hooks/useLocalStorage";
import { useApiClient } from "../../Services/api/logisticsServices"

import { useNavigate, useParams } from "react-router-dom";
import { convertToObject } from "typescript";
import UnSavedModal from "../common/UnSavedModal"
import { useAppContext } from '../../../hooks/context/AppContext';
import { useLoader } from "../../../pages/LoaderContext";
import { useProjectApiClient } from "../../Services/api/projectService"
import ValidationModal from "../common/ValidationModal"
import AutoSaveModal from "../common/AutoSaveModal"
import useIdle from '../../../hooks/useIdle';
import { projectVersion } from "config/navConfig";
import FileUpload from "../common/FileUpload";
import UploadList from "v2/components/common/UploadsList";
import circleArrowIcon from "../../../assets/images/circle-arrow-icon.svg"
import uploadIcon from "../../../assets/images/upload-icon.svg";



const useStyles = makeStyles({
  themeButton: {
    backgroundColor: '#2a3fbf !important',
    padding: "8px 30px",
    fontWeight: "700",
    '&:hover': { backgroundColor: '#2a3fbf !important' },
  },
  cancelButton: {
    backgroundColor: "#d9d9d9 !important",
    color: "#626262 !important",
    padding: "8px 30px",
    fontWeight: "700",
    '&:hover': { backgroundColor: '#d9d9d9 !important', color: '#626262 !important' },
  }
});


const schema = yup.object().shape({
  freightType: yup.mixed().nullable(),
  palletSpecification: yup.mixed().nullable(),
  shipmentRequirement: yup.mixed().nullable(),
  designToDistribute: yup.mixed().nullable(),
  whRequirement: yup.mixed().nullable(),
  risk: yup.mixed().nullable(),
  comment: yup.string().nullable(),
});

interface AuditEntry {
  fieldName: string;
  oldValue: string;
  newValue: string;
}

const LogisticsForm: React.FC = () => {
  const location = useLocation();

  const {
    getProjectDetails,
    getRequiredField,
    publishProjectOnSave,
    uploadProjectFile
  } = useProjectApiClient();
  const { projectId, projectKey } = useParams<{ projectKey: string; projectId: string }>();
  const { createLogistics, getDesignToDistributeComplete, getLogistics, getLogisticsRisk, getLSFreight, getLSPalletSpecifications, getLSShipmentRequirement, getWhRequirements, updateLogistics } = useApiClient();
  const { appData, updateAppData, userData } = useAppContext();
  const navigate = useNavigate();
  const classes = useStyles();
  const [freightTypes, setFreightType] = useState([])
  const [palletSpecifications, setPalletSpecifications] = useState([])
  const [shipmentRequirements, setShipmentRequirements] = useState([])
  const [designToDistributes, setDesignToDistributes] = useState([])
  const [whRequirements, setWhRequirements] = useState([])
  const [risks, setRisks] = useState([])
  const [isExisting, setIsExisting] = useState(false)
  const [isDisabled, setIsDisabled] = useState(true);
  const { loading, setLoading } = useLoader();
  const [validationErrors, setValidationErrors] = useState({})
  const [isValidationError, setIsValidationError] = useState(false)
  const [projectDetails, setProjectDetails] = useState({
    issaved: false
  })
  const [isDraftDisabled, setIsDraftDisabled] = useState(false);
  const [autoSaveModal, setAutoSaveModal] = React.useState<boolean>(false);
  const isIdle = useIdle(60000 * 10)
  const hasAutoSaved = useRef(false);
  const [isUpload, setIsUpload] = React.useState<boolean>(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const [formData, setFormData] = useState({
    freightType: '',
    palletSpecification: '',
    shipmentRequirement: '',
    designToDistribute: '',
    whRequirement: '',
    risk: '',
    comment: ''
  })

  const [initialformData, setInitialformData] = useState({
    freightType: '',
    palletSpecification: '',
    shipmentRequirement: '',
    designToDistribute: '',
    whRequirement: '',
    risk: '',
    comment: ''
  })
  const {
    handleSubmit,
    control,
    clearErrors,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });


  useEffect(() => {
    if (userData) {
      setIsDisabled(!userData.permissions.CanEdit)
    }
  }, [userData]);


  useEffect(() => {
    if (isIdle && !autoSaveModal) {
      let check = JSON.stringify(formData) === JSON.stringify(initialformData);
      if (!check && !hasAutoSaved.current) {
        setAutoSaveModal(true);
      }
    }
  }, [isIdle]);


  useEffect(() => {

    const fetchOptions = async () => {
      await Promise.all([
        fetchFreight(),
        fetchPalletSpecifications(),
        fetchgetShipmentRequirement(),
        fetchDesignToDistributeComplete(),
        fetchWhRequirements(),
        fetchLogisticsRisk(),
        fetchsProjectDetails()
      ]);
    };
    fetchOptions();
    if (projectKey) {
      fetchLogistics(projectKey);
    }
  }, []);


  useEffect(() => {
    let check = JSON.stringify(formData) == JSON.stringify(initialformData);
    if (!check) {
      updateAppData({ isFormChanged: true, showUnSavedModal: false });
    } else {
      updateAppData({ isFormChanged: false, showUnSavedModal: false });
    }

  }, [formData]);


  const fetchsProjectDetails = async () => {
    try {
      const data = await getProjectDetails(projectId);
      if (data) {
        setProjectDetails({ issaved: data.issaved });
        setIsDraftDisabled(data.issaved);
      }

    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };


  const fetchLogistics = async (key: string) => {
    try {
      setLoading(true)
      const response = await getLogistics(key);
      setLoading(false)
      const data = response.data;
      if (data) {
        if (data.Logistics_Id) {
          setIsExisting(true)
        }
        let logisticsData = {
          freightType: JSON.stringify(data.Freight_Type_Key),
          palletSpecification: JSON.stringify(data.Pallet_Specifications),
          shipmentRequirement: JSON.stringify(data.Shipment_Requirement_Key),
          designToDistribute: JSON.stringify(data.Design_To_Distribute_Complete),
          whRequirement: JSON.stringify(data.Wh_Requirements),
          risk: JSON.stringify(data.Risk_Key),
          comment: data.Comment
        }
        setFormData(logisticsData)
        setInitialformData(logisticsData)
        window.setTimeout(() => {
          Object.keys(logisticsData).forEach((key) => {
            setValue(
              key as any,
              logisticsData[key as keyof typeof logisticsData]
            );
          });
        }, 0);
      }
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    }
  };


  const fetchFreight = async () => {
    try {
      const data = await getLSFreight();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez
      }));
      setFreightType(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  const fetchPalletSpecifications = async () => {
    try {
      const data = await getLSPalletSpecifications();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez
      }));
      setPalletSpecifications(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };
  const fetchgetShipmentRequirement = async () => {
    try {
      const data = await getLSShipmentRequirement();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez
      }));
      setShipmentRequirements(output)
    } catch (error) {
      console.error(" Failed to fetch  Shipment Requirements:", error);
    } finally {
    }
  };
  const fetchDesignToDistributeComplete = async () => {
    try {
      const data = await getDesignToDistributeComplete();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez
      }));
      // @ts-ignore
      setDesignToDistributes(output)
    } catch (error) {
      console.error(" Failed to Design To Distributes:", error);
    } finally {
    }
  };
  const fetchWhRequirements = async () => {
    try {
      const data = await getWhRequirements();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez
      }));
      // @ts-ignore
      setWhRequirements(output)
    } catch (error) {
      console.error(" Failed to fetch WH Requirements:", error);
    } finally {
    }
  };
  const fetchLogisticsRisk = async () => {
    try {
      const data = await getLogisticsRisk();
      let output = data.map((item: any) => ({
        key: item.Risk_key,
        value: item.Risk_name
      }));
      setRisks(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  const fetchRequiredField = async () => {
    try {
      const data = await getRequiredField(projectKey);
      return data
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {

    }
  };

  let groupByModule = (errors: any) => {
    return errors.reduce((grouped: any, error: any) => {
      const { ModuleName, Message } = error;
      if (!grouped[ModuleName]) {
        grouped[ModuleName] = [];
      }
      grouped[ModuleName].push(Message);
      return grouped;
    }, {});
  }

  let closeValidationModal = () => {
    setIsValidationError(false)
    setValidationErrors({})
  }
  let pubLishProjectData = async () => {
    let res = await publishProjectOnSave(projectKey)
    if (res && res.issaved !== undefined) {
      setProjectDetails({ issaved: res.issaved });
      setIsDraftDisabled(res.issaved);
    }
  }


  const getCompleteAuditTrail = (initialData: Record<string, any>, updatedData: Record<string, any>): AuditEntry[] => {
    const audit: AuditEntry[] = [];
    const keys = Object.keys(initialData);
    for (const key of keys) {
      if (key === 'project_id') continue;

      const oldValue = initialData[key];
      const newValue = updatedData[key];

      audit.push({
        fieldName: key,
        oldValue: String(oldValue),
        newValue: String(newValue)
      });
    }

    return audit;
  }

  const onSubmit = async (data: any, type: any, url: string) => {
    let resField = await fetchRequiredField()
    if ((type === true) && (resField?.data && resField?.data.length)) {
      const groupedErrors = groupByModule(resField?.data);
      setValidationErrors(groupedErrors)
      setIsValidationError(true)
      return
    }
    setLoading(true)
    let payload = {
      "Project_Key": projectKey,
      "Freight_Type_Key": data.freightType,
      "Pallet_Specifications": data.palletSpecification,
      "Shipment_Requirement_Key": data.shipmentRequirement,
      "Design_To_Distribute_Complete": data.designToDistribute,
      "Wh_Requirements": data.whRequirement,
      "Comment": data.comment,
      "Risk_Key": data.risk
    }
    let initialPayload = {
      "Project_Key": projectKey,
      "Freight_Type_Key": initialformData.freightType,
      "Pallet_Specifications": initialformData.palletSpecification,
      "Shipment_Requirement_Key": initialformData.shipmentRequirement,
      "Design_To_Distribute_Complete": initialformData.designToDistribute,
      "Wh_Requirements": initialformData.whRequirement,
      "Comment": initialformData.comment,
      "Risk_Key": initialformData.risk
    }
    const completeAuditTrail = getCompleteAuditTrail(initialPayload, payload);
    {/* @ts-ignore */ }
    payload.audit = completeAuditTrail;
    if (!isExisting) {
      {/* @ts-ignore */ }
      let res = await createLogistics(payload)
      if (type === true) { await pubLishProjectData(); setProjectDetails({ issaved: true }); setIsDraftDisabled(type) };
      setLoading(false)
      if (res) {
        setIsExisting(true)
        {/* @ts-ignore */ }
        successToast(res.message)
        setTimeout(() => {
          if (type === true) { navigate(url ? url : `${projectVersion}/project/logistics/${projectId}/${projectKey}`); }
          else { navigate(url ? url : `${projectVersion}/project/kpi-summary/${projectId}/${projectKey}`); }
        }, 3000);
      }
    } else {
      {/* @ts-ignore */ }
      let res = await updateLogistics(payload, projectKey)
      if (projectKey) {
        fetchLogistics(projectKey);
      }
      if (type === true) { await pubLishProjectData(); setProjectDetails({ issaved: true }); setIsDraftDisabled(type) };
      setLoading(false)
      if (res) {
        {/* @ts-ignore */ }
        successToast(type ? res.message : 'Logistics details saved as draft ')
        setTimeout(() => {
          if (type === true) { navigate(url ? url : `${projectVersion}/project/logistics/${projectId}/${projectKey}`); }
          else { navigate(url ? url : `${projectVersion}/project/kpi-summary/${projectId}/${projectKey}`); }
        }, 3000);
      }
    }
  }

  const handleFormSubmit = (type: any, url: string) => {
    return handleSubmit((data) => onSubmit(data, type, url));
  };
  let handleFilterChange = async (name: any, value: any) => {
    setFormData({
      ...formData,
      [name]: value
    })
    hasAutoSaved.current = false;
  }

  let handleFormChange = (name: any, value: any) => {
    setFormData({
      ...formData,
      [name]: value
    })
    hasAutoSaved.current = false;
  }

  let closeUnSavedModal = () => {
    updateAppData({ isFormChanged: true, showUnSavedModal: false, url: '' });
  }
  let saveUnSavedModal = () => {
    updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
    handleFormSubmit(true, appData.url)()
  }
  let draftSavedModal = () => {
    updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
    handleFormSubmit(false, appData.url)()
  }
  const discardModal = () => {
    // reset form, redirect, or just close modal  
    updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
    navigate(appData.url);
  };
  let handleCancel = () => {
    if (!appData.isFormChanged) {
      navigate(`${projectVersion}/projects-grid`)
    } else {
      updateAppData({ isFormChanged: true, showUnSavedModal: true });
    }

  }

  const autoSave = async () => {
    setAutoSaveModal(false);
    try {
      let resField = await fetchRequiredField()
      if (resField?.data && resField?.data.length) {
        await handleFormSubmit(false, '')();
        hasAutoSaved.current = true;
      } else {
        await handleFormSubmit(true, '')();
        hasAutoSaved.current = true;
      }
    } catch (error) {
      console.error("Auto-save failed:", error);
    }
  };

  let closeAutoSave = () => {
    setAutoSaveModal(false)
  }

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const uploadFlag = searchParams.get("isUpload") === "true";
    if (uploadFlag) {
      setIsUpload(true);
      searchParams.delete("isUpload");
    }
  }, [location.search, location.pathname]);

  let handlebackUpload = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete("isUpload");

    navigate(
      {
        pathname: location.pathname,
        search: searchParams.toString()
          ? `?${searchParams.toString()}`
          : "", // no query string if empty
      },
      { replace: true }
    );

    setIsUpload(false);
  };

  const handleProjectFileChange = async (file: any) => {
    const allowedTypes = [
      'application/pdf',
      'application/msword',                       // .doc
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
      'application/vnd.ms-excel',                 // .xls
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',       // .xlsx
      'application/vnd.ms-powerpoint',            // .ppt
      'application/vnd.openxmlformats-officedocument.presentationml.presentation' // .pptx
    ];
    if (!allowedTypes.includes(file.type)) {
      errorToast('Only PDF, PPT, XLS or DOC formats are allowed.');
      return;
    }
    setLoading(true)
    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB in bytes
    if (file.size > MAX_FILE_SIZE) {
      errorToast('File size must be less than 5 MB');
      return;
    }
    try {
      const formdata = new FormData();
      formdata.append("file", file, file.name);
      let data = await uploadProjectFile(projectKey, 9, formdata);
      //  successToast(data.message)
      setLoading(false)
      setRefreshTrigger(prev => prev + 1);

    } catch (error) {
      console.error('Error uploading file:', error);
      errorToast('Failed to upload file. Please try again.');
    }
  };

  let handleClickUpload = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("isUpload", "true");

    navigate(
      {
        pathname: location.pathname,
        search: `?${searchParams.toString()}`,
      },
      { replace: true }
    );
    setIsUpload(true);
  };

  return (
    <>
      <ToastContainer />
      <div className="create-project-content">
        <Card className="" sx={{ padding: "30px", borderRadius: "20px", pt: 3 }}>

          {/* Buttons - Save, Draft, Cancel */}
          <Box>
            <div className="button-top-form" style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Stack
                direction="row"
                spacing={2}
                sx={{ justifyContent: "start", pb: 4 }}
              >
                {
                  isUpload ?
                    <Button onClick={() => handlebackUpload()} sx={{ border: '0px', fontSize: '14px', color: '#B5B5B5', p: 0, textTransform: 'capitalize' }}><img src={circleArrowIcon} className="wtsback--img" /></Button>
                    :
                    null
                }

              </Stack>
              {
                !isUpload ?
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{ justifyContent: "end", pb: 4 }}
                  >
                    {
                      localStorage.user_info && JSON.parse(localStorage.user_info).Role !== '' ?
                        JSON.parse(localStorage.user_info).Role !== 'ProjectViewer' ?
                          <Tooltip title="Upload Documents" arrow>
                            <Button
                              onClick={() => handleClickUpload()}
                              sx={{ p: 0, minWidth: 'auto', width: '38px', height: '38px', border: '1px solid #000', borderRadius: '50%' }}
                            >
                              <img src={uploadIcon} className="icon-wt-uplad" />
                            </Button>
                          </Tooltip>
                          :
                          <>
                          </>
                        :
                        null
                    }
                    <Button disabled={isDisabled} onClick={handleFormSubmit(true, '')} variant="contained"
                      sx={{ borderRadius: '30px', px: 4, py: 1, textTransform: 'capitalize', color: 'white !important', backgroundColor: `${isDisabled ? '#d9d9d9 !important' : '#2a3fbf !important'}` }} className={classes.themeButton}>Submit</Button>

                    <Button
                      disabled={isDisabled || projectDetails.issaved}
                      onClick={handleFormSubmit(false, '')}
                      variant="contained"
                      sx={{
                        borderRadius: '30px',
                        px: 4,
                        py: 1,
                        textTransform: 'capitalize',
                        color: 'white !important',
                        backgroundColor: '#2a3fbf !important',
                        '&.Mui-disabled': {
                          backgroundColor: '#d9d9d9 !important',
                          color: '#5f6368 !important'
                        }
                      }}
                      className={classes.themeButton}
                    >
                      Draft & Continue
                    </Button>
                    <Button disabled={isDisabled} onClick={handleCancel} variant="contained" sx={{ borderRadius: '30px', px: 4, py: 1, textTransform: 'capitalize' }} className={classes.cancelButton}>Cancel</Button>

                  </Stack>
                  :
                  <>
                    <div className="file-upload-button">
                      <FileUpload isProjectUpload={true} isDisabled={false} onFileChange={handleProjectFileChange}
                        name="uploadPic" label="Browse" control={control} errors={errors} />
                    </div>
                  </>
              }


            </div>
          </Box>
          {
            isUpload ?
              <>
                {/* @ts-ignore */}
                <UploadList refreshTrigger={refreshTrigger} setLoading={setLoading} moduleId={9}></UploadList>
              </>
              :
              <form noValidate>
                <Grid container spacing={3}>
                  <Grid size={12}>
                    {/* <h5 className="txt-mandatory-title">*Fields are mandatory</h5> */}
                  </Grid>
                  <Grid size={4}>
                    <label className="txt-label-input">Freight Type<span className="required-txt"></span></label>
                    <div className="project_drpdnw">
                      <Controller
                        name="freightType"
                        control={control}
                        render={({ field }) => (
                          <SelectDropdown
                            isDisabled={isDisabled}
                            filterKey=""
                            label=""
                            value={field.value}
                            onChange={(val) => {
                              field.onChange(val);
                              handleFilterChange("freightType", val);
                              clearErrors("freightType");
                            }}
                            options={freightTypes}
                            isError={!!errors.freightType}
                          />
                        )}
                      />
                    </div>
                    {errors.freightType && <p className="error-message">{errors.freightType.message}</p>}
                  </Grid>

                  <Grid size={4}>
                    <label className="txt-label-input">Pallet Specifications<span className="required-txt"></span></label>
                    <div className="project_drpdnw">
                      <Controller
                        name="palletSpecification"
                        control={control}
                        render={({ field }) => (
                          <SelectDropdown
                            isDisabled={isDisabled}
                            filterKey=""
                            label=""
                            value={field.value}
                            onChange={(val) => {
                              field.onChange(val);
                              handleFilterChange("palletSpecification", val);
                              clearErrors("palletSpecification");
                            }}
                            options={palletSpecifications}
                            isError={!!errors.palletSpecification}
                          />
                        )}
                      />
                    </div>
                    {errors.palletSpecification && <p className="error-message">{errors.palletSpecification.message}</p>}
                  </Grid>

                  <Grid size={4}>
                    <label className="txt-label-input">Shipment Requirement<span className="required-txt"></span></label>
                    <div className="project_drpdnw">
                      <Controller
                        name="shipmentRequirement"
                        control={control}
                        render={({ field }) => (
                          <SelectDropdown
                            isDisabled={isDisabled}
                            filterKey=""
                            label=""
                            value={field.value}
                            onChange={(val) => {
                              field.onChange(val);
                              handleFilterChange("shipmentRequirement", val);
                              clearErrors("shipmentRequirement");
                            }}
                            options={shipmentRequirements}
                            isError={!!errors.shipmentRequirement}
                          />
                        )}
                      />
                    </div>
                  </Grid>



                  <Grid size={4}>
                    <label className="txt-label-input">Design to Distribute Complete<span className="required-txt"></span></label>
                    <div className="project_drpdnw">
                      <Controller
                        name="designToDistribute"
                        control={control}
                        render={({ field }) => (
                          <SelectDropdown
                            isDisabled={isDisabled}
                            filterKey=""
                            label=""
                            value={field.value}
                            onChange={(val) => {
                              field.onChange(val);
                              handleFilterChange("designToDistribute", val);
                              clearErrors("designToDistribute");
                            }}
                            options={designToDistributes}
                            isError={!!errors.designToDistribute}
                          />
                        )}
                      />
                    </div>
                  </Grid>


                  <Grid size={4}>
                    <label className="txt-label-input">WH Requirements<span className="required-txt"></span></label>
                    <div className="project_drpdnw">
                      <Controller
                        name="whRequirement"
                        control={control}
                        render={({ field }) => (
                          <SelectDropdown
                            isDisabled={isDisabled}
                            filterKey=""
                            label=""
                            value={field.value}
                            onChange={(val) => {
                              field.onChange(val);
                              handleFilterChange("whRequirement", val);
                              clearErrors("whRequirement");
                            }}
                            options={whRequirements}
                            isError={!!errors.whRequirement}
                          />
                        )}
                      />
                    </div>
                  </Grid>
                </Grid>
                <Grid container spacing={2} mt={2}>
                  <Grid size={8}>
                    <label className="txt-label-input">Comment<span className="required-txt"></span></label>
                    <TextInput isDisabled={isDisabled} className="comment-input" isComment={true} onChange={(e) => handleFormChange(e.target.name, e.target.value)} name="comment" label="" control={control} errors={errors} multiline />
                  </Grid>
                  <Grid size={4}>
                    <label className="txt-label-input">Logistics Risk<span className="required-txt"></span></label>
                    <div className="project_drpdnw">
                      <Controller
                        name="risk"
                        control={control}
                        render={({ field }) => (
                          <SelectDropdown
                            isDisabled={isDisabled}
                            filterKey=""
                            label=""
                            value={field.value}
                            onChange={(val) => {
                              field.onChange(val);
                              handleFilterChange("risk", val);
                              clearErrors("risk");
                            }}
                            options={risks}
                            isError={!!errors.risk}
                          />
                        )}
                      />
                    </div>
                  </Grid>
                </Grid>

              </form>
          }
        </Card>
      </div>

      {/* @ts-ignore */}
      <UnSavedModal close={closeUnSavedModal} saveUnSavedModal={saveUnSavedModal} draftSavedModal={draftSavedModal} discardModal={discardModal} isDraftDisabled={isDraftDisabled} />
      <ValidationModal validationErrors={validationErrors} open={isValidationError} closeValidationModal={closeValidationModal} />
      <AutoSaveModal open={autoSaveModal} closeAutoSave={closeAutoSave} autoSave={autoSave} ></AutoSaveModal>
    </>
  );
};

export default LogisticsForm;